import { OnInit, Injector } from '@angular/core';
import { Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy, Inject } from '@angular/core';
import { Component, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Utils } from 'formiojs';
import { Subscription } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResourceNameService, SuccessToast } from 'dp-formio';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;
@Component({
  selector: 'add-edit-editgrid-content',
  templateUrl: 'add-edit-editgrid-content.component.html',
  styleUrls: ['./add-edit-editgrid-content.component.scss'],
})
export class AddEditEditgridContent implements OnInit, OnChanges, OnDestroy {
  @Input() data: any;
  @Output() close = new EventEmitter<any>();

  submissionId: string;
  submission: any = {};
  formReady = false;

  dialogRef: MatDialogRef<AddEditEditgridContent>;
  dialogData: any;

  readConfigFrom: string;
  backToGrid = true;

  private subs: Subscription[] = [];
  set sub(s: Subscription) {
    this.subs.push(s);
  }

  constructor(
    public fb: FormBuilder,
    private resourceNameService: ResourceNameService,
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private injector: Injector
  ) {
    try {
      this.dialogRef = injector.get(MatDialogRef);
      this.dialogData = injector.get(MAT_DIALOG_DATA);
    } catch { }
  }

  ngOnInit() {
    if (!this.data) {
      this.data = this.dialogData;
      this.ngOnChanges(null);
    }
    $('.custom-modal-component mat-dialog-container').scroll(function () {
      $('.flatpickr-calendar').each((i, item) => {
        $(item).removeClass('open');
      });
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.formReady = false;
    this.submissionId = '';
    this.submission = {};

    setTimeout(() => {
      let extraOptions = {};
      if (this.data.extra)
        extraOptions = Utils.evaluate(this.data.extra, {
          submission: this.data.data,
          editGridItems: this.data.editGridItems,
          rowSubmission: this.data.rowSubmission,
        });

      if (this.data.rowSubmission) this.submissionId = this.data.rowSubmission._id;

      this.readConfigFrom = this.data.resource?.readConfigFrom;
      this.loadResource(extraOptions);
    });
  }

  loadResource(extraOptions: any) {
    if (this.submissionId) {
      const resource = this.data.resource?.writeSubmissionOn || this.data.resource;
      const method = this.data.isEndpoint ?
        this.resourceNameService.loadById(this.data.evaluatedUrl, this.submissionId) :
        this.resourceNameService.loadCustomByKeyId(resource, this.submissionId);

      this.sub = method.subscribe((data) => {
        this.submission = data;
        this.submission.data = { ...extraOptions, ...this.submission.data };
        this.formReady = true;
      });
    } else {
      this.submission.data = { ...extraOptions };
      this.formReady = true;
    }
  }

  onFormLoad() {
    try {
      setTimeout(() => {
        const button = $('#columnsCancel');
        if (!button) {
          this.onFormLoad();
          return;
        }
        setTimeout(() => button.prop('disabled', false), 500);
      }, 350);
    } catch (e) { }
  }

  onSubmit(submission) {
    console.log(submission);
    if (this.data.isEndpoint) {
      this.sub = this.resourceNameService
        .saveByData(!this.submissionId, this.data.evaluatedUrl, submission.data)
        .subscribe((data) => {
          this.saveAndContinue(data);
        });
      return;
    }

    if (this.readConfigFrom) {
      this.sub = this.resourceNameService
        .saveResourceData(!this.submissionId, this.data.resource?.writeSubmissionOn, submission.data)
        .subscribe((data) => {
          this.saveAndContinue(data);
        });
    } else {
      this.saveAndContinue(submission);
    }
  }

  private saveAndContinue(data) {
    if (this.backToGrid) {
      this.closeWithSubmission(data);
    } else {
      if (this.data.closeActive) {
        this.data.rowSubmission = data;
        this.data.closeActive(this.data);
        this.data.rowSubmission = null;
      }
      this.ngOnChanges(null);
      this.toastrService.show(this.translateService.instant('forms.common.Save successfully'), '', {
        toastClass: 'notification-toast',
        closeButton: true,
        enableHtml: true,
        toastComponent: SuccessToast,
      });
    }

    this.backToGrid = true;
  }

  private closeWithSubmission(submission) {
    this.data.rowSubmission = submission;
    this.close.emit(this.data);
    if (this.dialogRef) this.dialogRef.close(this.data);
  }

  onCustomEvent(event) {
    if (event.type == 'customCancel') {
      this.backToGrid = true;
      this.close.emit();
      if (this.dialogRef) this.dialogRef.close();
    }
    else if (event.type == 'saveAndContinue') {
      if (!event.formComponent.formio.checkValidity(event.formComponent.formio.data, true)) {
        event.formComponent.onError(event.formComponent.formio.errors);
        return;
      }
      this.backToGrid = false;
      event.formComponent.submitForm(event.formComponent.submission);
    }
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
    this.subs = [];
  }
}
